import { maybe } from '@passionware/monads';

let timezone: string | null = null;
export function setSystemTimezone(tz: string): void {
  timezone = tz;
}

export function getSystemTimezone(): string {
  // return moment's default timezone (which is set by App.js)
  return maybe.getOrThrow(timezone, 'System timezone not set');
}
